export default {
  source: __DEV__
    ? 'https://v2.zopim.com/?5jqZjbGpGP6YgqzErW1nJpWbNSlp6aiu'
    : 'https://v2.zopim.com/?2WIf3gntyAOSFo5uPRKzkPLUnsSqBGhA',
};
